import { ErrorHandler, Injectable } from '@angular/core';
import { LogService } from './log.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private log: LogService) {}

  handleError(err: unknown) {
    this.log.error('UncaughtError', err instanceof Error ? err : String(err));
  }
}